import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import "./index.scss";

function AdminPopmenu({ items, onClose }) {
	return (
		<div className="admin-pop-menu">
			{items.map((item, i) =>
				item.newTab ? (
					<a
						className="admin-pop-link"
						href={item.to}
						target="_blank"
						rel="noopener noreferrer"
						key={i}
						onClick={onClose}
					>
						<span className="admin-pop-link-name">{item.text}</span>
						<span className="admin-pop-link-desc">{item.description}</span>
					</a>
				) : (
					<Link
						className="admin-pop-link"
						to={item.to}
						key={i}
						onClick={onClose}
					>
						<span className="admin-pop-link-name">{item.text}</span>
						<span className="admin-pop-link-desc">{item.description}</span>
					</Link>
				),
			)}
		</div>
	);
}

AdminPopmenu.propTypes = {
	onClose: PropTypes.func,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			description: PropTypes.string.isRequired,
			to: PropTypes.string.isRequired,
			newTab: PropTypes.bool,
		})
	).isRequired,
};

export default AdminPopmenu;
